import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/bas/app_b87cda9f-4054-4354-b92f-82f57d04f7dd/website/src/components_feature/Arborescence.tsx");
